import React, { useEffect, useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import { EventDetailDTO, EventResultDTO } from "../../../../models/EventDTO";
import S from "./strings";
import { dineroCod, errorText } from "../workshops/comun";

/** Resultado: ingresos (cobrado / pendiente, por tipo), costos y bruto. */
const ResultadoTab: React.FC<{ campusId: number; evento: EventDetailDTO; notify: (t: string, ok?: boolean) => void }> = ({ campusId, evento, notify }) => {
	const http = HttpManager.getInstance();
	const [r, setR] = useState<EventResultDTO | null>(null);
	useEffect(() => {
		let vigente = true;
		http.eventsService.result(campusId, evento.id).then(x => vigente && setR(x.data)).catch(e => notify(errorText(e), false));
		return () => { vigente = false; };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [campusId, evento]);
	if (!r) return <div className="wau-caja wau-sec">{S.cargando}</div>;
	const m = (v: number) => dineroCod(r.currency, v);
	const cifra = (label: string, v: number, oro = false) => <div><span className="wau-lab">{label}</span><div className={"wte-cifra" + (oro ? " oro" : "")}>{m(v)}</div></div>;
	const cuenta = (label: string, v: number) => <div><span className="wau-lab">{label}</span><div className="wte-cifra">{v}</div></div>;
	return (
		<div>
			<div className="wau-caja wte-grid">
				{cifra(S.ingresos, r.income.total)}
				{cifra(S.cobrado, r.income.collected)}
				{cifra(S.pendiente, r.income.pending, r.income.pending > 0)}
				{cifra(S.costosTotal, r.costsTotal)}
				{cifra(S.bruto, r.gross, r.gross < 0)}
				{cifra(S.brutoCobrado, r.grossCollected, r.grossCollected < 0)}
			</div>
			{/* R2: mesas ocupadas y togas/birretes (= graduadas y participantes vigentes) */}
			<div className="wau-caja wte-grid" style={{ marginTop: 10 }}>
				{cuenta(S.asistentesVigentes, r.attendees ?? evento.counts.total)}
				{cuenta(S.mesas, r.tables ?? 0)}
				{cuenta(S.togas, r.graduates ?? evento.counts.graduates)}
			</div>
			<div className="wau-dos">
				<div className="wau-caja wau-tabla">
					<h3>{S.porTipo}</h3>
					<table>
						<thead><tr><th>{S.colTipo}</th><th className="der">{S.cantidad}</th><th className="der">{S.ingresos}</th><th className="der">{S.cobrado}</th></tr></thead>
						<tbody>{r.income.byKind.map(k => <tr key={k.kind}><td>{k.label}</td><td className="der wau-num">{k.count}</td><td className="der wau-num">{m(k.income)}</td><td className="der wau-num">{m(k.collected)}</td></tr>)}</tbody>
					</table>
				</div>
				<div className="wau-caja wau-tabla">
					<h3>{S.costos}</h3>
					<table>
						<tbody>
							{r.costs.length === 0 ? <tr><td className="wau-sec">—</td></tr> : r.costs.map((c, i) => <tr key={i}><td>{c.concept}</td><td className="der wau-num">{m(c.amount)}</td></tr>)}
							<tr><td><b>{S.costosTotal}</b></td><td className="der wau-num"><b>{m(r.costsTotal)}</b></td></tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
};

export default ResultadoTab;
